import { Button } from "../../../components/Button";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";

export function Step5({ onContinue }: { onContinue: () => void }) {
    const {tenantProfile} = useApp()
    return (
        <div className="flex items-start gap-10 pb-10 pt-8 pl-5 pr-5">
            <div className="flex-1 flex justify-center flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <span className="text-black text-[21px] font-bold ">Did you know you're actually <span className="text-primary italic font-medium">supposed</span> to forget some things? </span>
                </div>
                <div className="w-full flex justify-center">
                    <SignedUrlImage s3Key="onboarding-4.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-1">
                <div>
                    <div className="flex flex-col gap-3 text-sm">
                        <span className="text-black font-medium ">The Spacing Effect:</span>
                        <p className="text-[#6B5959]">Your brain needs time to forget a little so it can re-strengthen the memory when you come back to it.</p>
                        <p className="text-[#6B5959]">Reminders will help you distribute your practice in short sessions over time instead of in lengthy sessions. </p>
                        <p className="text-[#6B5959]">Plus, you'll know when: </p>
                        <ul className="ml-3 list-disc text-[#6B5959] ">
                            <li>Your score increases</li>
                            <li>Your team ranking changes </li>
                            <li>Your manager leaves feedback</li>
                        </ul>
                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}